<template>
  <v-dialog v-model="isVisible" max-width="500">
    <v-card>
      <v-card-title class="headline">Error</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, defineProps, watch } from 'vue';

const props = defineProps({
  message: String,
  show: Boolean,
});

const isVisible = ref(props.show);

watch(() => props.show, (newVal) => {
  isVisible.value = newVal;
});

const close = () => {
  isVisible.value = false;
};
</script>